angular.module('app').factory('saveNavigationState', function($rootScope, $location) {
    "ngInject";
    var pending;

    $rootScope.$on('$routeChangeStart', function() {
        if (pending && pending.url !== $location.url()) {
            pending = null;
        }
    });

    return {
        remember: function(url, state) {
            pending = {url: url, state: state};
        },
        take: function() {
            var state = pending && pending.url === $location.url() ? pending.state : {};
            pending = null;
            return state;
        }
    };
});
